// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__+6Avm","warehouseAddress":"styles_warehouseAddress__6GYGb","customerAddress":"styles_customerAddress__4Bq2n"};